import * as React from "react";

export interface IsValidCheckmarkProps {
  isInvalid: boolean;
  hasValue: boolean;
}

export const IsValidCheckmark = (props: IsValidCheckmarkProps) => {
  return <div className={!props.isInvalid && props.hasValue ? "form-control--is-valid-indicator" : ""}></div>;
};
